<template>
  <div id="upload" :style="'width:' + width + 'px' + ';' + 'margin-left:' + marginleft + 'px'">
    <Upload class="addition" type="drag" multiple ref="uploadFile" :default-file-list="uploadList" :before-upload="handleUpload" :action="uploadUrl" :data="uploadData" :format="format" :max-size="maxSize" :on-success="uploadSuccess" :on-error="uploadError" :on-format-error="formatError" :on-exceeded-size="onExceededSize" :on-remove="onDelete" :on-preview="onPreview">
      <div :style="'height:' + height + 'px'">
        <Icon type="ios-cloud-upload" size="35" style="color: #3399ff"></Icon>
        <p>{{ title }}</p>
      </div>
    </Upload>
  </div>
  <!--   
    <plt-upload  @success="uploadSuccess" @delete="onDelete"></plt-upload>-->
</template>
<script>
export default {
  name: "upload",
  data() {
    return {
      uploadData: {},
      attachmentFileIds: [],
    };
  },
  props: {
    maxSize: {
      type: Number,
      default: 102400,
    },
    title: {
      type: String,
      default: "附件上传",
    },
    format: {
      type: Array,
      default: () => [
        "docx",
        "doc",
        "xls",
        "xlsx",
        "txt",
        "tif",
        "tiff",
        "msg",
        "pub",
        "ppt",
        "pptx",
        "7z",
        "xmind",
        "html",
        "mhtml",
        "mht",
        "rar",
        "zip",
        "psd",
        "jpg",
        "pdf",
        "png",
        "xlsx",
      ],
    },
    uploadUrl: {
      type: String,
      default: "/upload",
    },
    width: {
      type: Number,
      default: 600,
    },
    height: {
      type: Number,
      default: 55,
    },
    marginleft: {
      type: Number,
      default: 0,
    },
    uploadList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    // 上传之前调用
    handleUpload() {
      this.uploadData = {
        sessionId: this.pltSession.getSession(),
      };
      let promise = new Promise((resolve) => {
        this.$nextTick(function () {
          resolve(true);
        });
      });
      return promise;
    },

    // 上传成功
    uploadSuccess(response, file, fileList) {
      let { head } = response;
      if (head.returnType != "SUCCESS") {
        if (head.errorInfo.errorCode == -999999) {
          this.$Message.error("会话已过期,请重新登录");
          return this.$router.push("/login");
        } else {
          return this.$Message.error("上传失败!");
        }
      }
      this.$Message.success("上传成功!");
      this.$emit("success", { body: response.body, file: file });
    },
    // 删除文件回调
    onDelete(file, fileList) {
      if (file.response) {
        this.$emit("delete", { id: file.response.body });
      } else {
        this.$emit("delete", { id: file.url });
      }
    },
    // 上传失败回调
    uploadError() {
      this.$Message.error("上传失败!");
    },
    // 上传文件格式错误时钩子
    formatError() {
      this.$Message.error("上传图片或文件格式错误！");
    },
    onExceededSize() {
      this.$Message.error(`文件超出指定大小，最大上传${this.maxSize}KB`);
    },
    // 点击已上传的文件链接时
    onPreview(file) {
      var src = `/download?sessionId=${this.pltSession.getSession()}&id=`;
      var tempwindow = window.open("_blank");
      if (file.response) {
        tempwindow.location = `${src}${file.response.body}&disposition=inline`;
      } else {
        tempwindow.location = `${src}${file.url}&disposition=inline`;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#upload {
  margin-left: 20px;
}
</style>